import { ChosenDilemmaCard } from "../../molecules/Board/subBoardComponents";
import { useCard } from "../../../hooks";
import { CardSlot, MainButton } from "../../atoms";
import { CardType } from "../../../util/enums";
import { TableContext, TeamContext, UserContext } from "../../../context";
import { useContext } from "react";
import { IPlayer } from "../../../interfaces";
import focusButton from "../../../assets/icons/focusButton.svg";
import instructionArrow from "../../../assets/icons/instructionArrow.svg";
import { useTranslation } from "react-i18next";

const MySolutionCardsFullScreen = () => {
    const { game } = useContext(TeamContext);
    const { t } = useTranslation();
    const { userData, playersInNewOrder } = useContext(UserContext);
    const { setToggleMySolutionFullScreen, didTheCurrentUserProposedSolution } = useContext(TableContext);
    const [card] = useCard();


    const userColor = () => {
        return playersInNewOrder.find((player: IPlayer) => { return player?.email === userData?.email })?.color || "";
    }

    return (
        <div className="dilemma_owner_anouncement_wrapper center_horizontally_and_vertically full_screen_vw_vh">
            {didTheCurrentUserProposedSolution &&
                <div className="my_solution_cards_full_screen_focus_mode_title">
                    <img className="my_solution_cards_full_screen_focus_mode_icon" src={focusButton} alt="focus mode" />
                    <div>
                        <div> {t("focusModeText")} </div>
                        <div className="gradient_line_holder center_horizontally_and_vertically" style={{width: "100%"}}>
                            <div className="linear_gradient_line_horizontal" style={{ width: "100%" }}></div>
                        </div>   
                    </div>
                </div>
            }
            <div className="my_solution_cards_full_screen">
                <div className="my_solution_cards_full_screen_dilemma_card_wrapper" >    
                    <div className="my_solution_cards_full_screen_dilemma_card_scale">     
                        <ChosenDilemmaCard isFullScreenOn={true} isTheFullScreenOn={false} />
                    </div>
                </div>
                <div className="gradient_line_holder center_horizontally_and_vertically" style={{width: "100%"}}>
                    <div className="linear_gradient_line_horizontal" style={{ width: "100%" }}></div>
                </div>
                <div className="my_solution_cards_full_screen_my_image_text_wrapper" >
                    <div className="my_solution_cards_full_screen_my_image_wrapper">
                        <img
                            className={`my_solution_cards_full_screen_my_image border_color_${userColor()} `}
                            src={`${process.env.REACT_APP_BACKEND_URL}images/${userData?.email}.png`}
                            alt="Profile Icon"
                        />  
                    </div>
                    <div className="my_solution_cards_full_screen_text dislay_flex" > 
                        {t("readYourCardsCarefullyAndSuggestASlutionText")} 
                        <div className="instruction_arrow_wrapper">
                            <div className="margin_left_10 bracet">(</div>
                            <img className="width_40px" src={instructionArrow} alt="instructionArrow" />
                            <div className="bracet">)</div>
                        </div>
                    </div>
                </div>
                <div className="my_solution_cards_full_screen_cards_wrapper"> 
                    <div className="my_solution_cards_full_screen_card_wrapper transform_bottom_left">
                        <CardSlot card={card(CardType.EMOTIONAL_SOLUTION)} fullScreenIsOn={true} />
                    </div>
                    <div className="my_solution_cards_full_screen_card_wrapper transform_bottom_left">
                        <CardSlot card={card(CardType.SOCIAL_SOLUTION)} fullScreenIsOn={true} />
                    </div>
                    <div className="my_solution_cards_full_screen_card_wrapper transform_bottom_center">
                        <CardSlot card={card(CardType.MENTAL_SOLUTION)} fullScreenIsOn={true} />
                    </div>
                    <div className="my_solution_cards_full_screen_card_wrapper transform_bottom_right">
                        <CardSlot card={card(CardType.PHYSICAL_SOLUTION)} fullScreenIsOn={true} />
                    </div>
                    <div className="my_solution_cards_full_screen_card_wrapper transform_bottom_right">
                        <CardSlot card={card(CardType.JOKER_SOLUTION)} fullScreenIsOn={true} />
                    </div>
                </div>
                {didTheCurrentUserProposedSolution &&
                    <div className="my_solution_cards_full_screen_back_button_wrapper">
                        <div className="my_solution_cards_full_screen_back_button">
                            <MainButton text={t("backToTheTableText")} type="big" clickHandler={() => setToggleMySolutionFullScreen(false)} disabled={false}/>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default MySolutionCardsFullScreen;